import { CountryBadge } from "@/components/go/CountryBadge";
import { SectionHelpTooltip } from "@/components/shared/SectionHelpTooltip";

export type GeoContextPanelProps = {
  title?: string;
  ginfObjId?: number | null;
  name?: string | null;
  iso?: string | null;
  facts?: Array<{ label: string; value: string }>;
  emptyHint?: string;
  onOpenInGo?: (ginfObjId: number) => void;
};

/** Блок geo-context для встраивания в другие модули (контракт GO-9). */
export function GeoContextPanel({
  title = "Географический контекст",
  ginfObjId,
  name,
  iso,
  facts = [],
  emptyHint = "Нет привязанной сущности ГО",
  onOpenInGo,
}: GeoContextPanelProps) {
  if (ginfObjId == null && !name && !iso) {
    return (
      <div className="rounded-md border border-dashed border-border px-3 py-2 text-xs text-muted-foreground">
        {emptyHint}
      </div>
    );
  }
  return (
    <div className="space-y-2 rounded-md border border-border px-3 py-2">
      <div className="flex items-center gap-1.5 text-sm font-medium text-foreground">
        {title}
        <SectionHelpTooltip label="Справка geo-context">
          <p>Сводка страны/сущности ГО для смежных модулей.</p>
          <p className="mt-1">Deep-link в `/go?entityId=` открывает Country Hub.</p>
        </SectionHelpTooltip>
      </div>
      <CountryBadge
        name={name}
        iso={iso}
        ginfObjId={ginfObjId}
        onOpen={onOpenInGo}
      />
      {facts.length > 0 ? (
        <dl className="grid gap-1 text-xs text-muted-foreground">
          {facts.map((f) => (
            <div key={f.label} className="flex justify-between gap-2">
              <dt>{f.label}</dt>
              <dd className="text-foreground truncate">{f.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </div>
  );
}
